
const MEMPACK_LIST = 'MEMPACK_LIST';
const MEMPACK_PAGE = 'MEMPACK_PAGE';
const MEMPACK_CONDITION = 'MEMPACK_CONDITION';

const MempackageListModel = function () {
  const name = 'MempackageList';
  return {
    name,
    state: {
      list: [],
      condition: {
        status:1,    
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: MEMPACK_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: MEMPACK_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: MEMPACK_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = MempackageListModel.state.list, action) => {
        if (action.type === MEMPACK_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = MempackageListModel.state.page, action) => {
        if (action.type === MEMPACK_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = MempackageListModel.state.condition, action) => {
        if (action.type === MEMPACK_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
    }
  };
}();

export default MempackageListModel;


// WEBPACK FOOTER //
// ./src/models/MempackageListModel.js